import { render, staticRenderFns } from "./afterSalesDetails.vue?vue&type=template&id=6b6b4d0d&scoped=true&"
import script from "./afterSalesDetails.vue?vue&type=script&lang=js&"
export * from "./afterSalesDetails.vue?vue&type=script&lang=js&"
import style0 from "./afterSalesDetails.vue?vue&type=style&index=0&id=6b6b4d0d&prod&lang=scss&scoped=true&"
import style1 from "./afterSalesDetails.vue?vue&type=style&index=1&id=6b6b4d0d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b4d0d",
  null
  
)

export default component.exports